import { z } from 'zod';

import { requiredEmailFieldSchema } from '@src/features/customers/auth/core/requiredEmailFieldSchema';
import { isValidVerificationCode } from '@src/domains/customers';
import type { Translate } from '@src/i18n/useTranslate';

export const otpLoginFormSchema = (t: Translate['i18n']) => {
  const requiredMessage = t('checkout_auth_required_field');
  const invalidCodeMessage = t('auth_invalid_verification_code');

  return z.object({
    email: requiredEmailFieldSchema(t),
    otp: z
      .string({ required_error: requiredMessage })
      .min(1, requiredMessage)
      .refine(isValidVerificationCode, { message: invalidCodeMessage }),
  });
};

export type OtpLoginFormValues = z.infer<ReturnType<typeof otpLoginFormSchema>>;
